import { STATE } from "../classes/Enum";
import ProductImageComponent from "./ProductImage";
import '../styles/product.css';
import '../styles/pokeball.css';

function Product({item, addToCart, count}) {
    const oos = item.quantity <= 0;

    function formatString(seriesName, setName) {
        if (seriesName && setName) {
            return seriesName + " | " + setName;
        }
        if (seriesName === null) {
            seriesName = "";
        }
        if (setName === null) {
            setName = "";
        }
        return seriesName + " " + setName;
    }

    function getDollarAmount(price) {
        let dollar = 0;
        if (price >= 1) {
            dollar = price.toString().split('.')[0];
        }
        return dollar;
    }

    function getCentAmount(price) {
        const priceArr = price.toString().split('.');
        if (priceArr[1] === '00') {
            return;
        }
        return  priceArr[1];
    }

    const TextModule = () => {
        return <div className="row center">
            <div className="flex-end">
                <h1>{count}</h1>
                <div>in cart</div>
            </div>
            <button className='quick-add' onClick={() => addToCart(item)}>
                    <img src="assets/imgs/add-cart-pokeball.png"></img>
                </button>
            <div className="flex-start">
                {item.quantity > 50 ? <>
                    <h1>50+</h1>
                    <h4>available</h4>
                </>
                : 
                <>
                    <h1>{item.quantity}</h1>
                    <h4>available</h4>
                </> }
            </div>
            </div>
    }

    return (<div className='item-card'>
        <ProductImageComponent item={item} greyscale={oos} />
        <div className="item-text-container">
            <h3>{item.name}</h3>
            <p>{item.type === STATE.SINGLE ? formatString(item.seriesName, item.setName) : null}</p>
            <p>{item.subtext}</p>
            <div style={{ display:'flex', fontSize: '25px', flexDirection:'row', justifyContent:'center'}}>
                <h3>${getDollarAmount(item.price)}</h3>
                <p>{getCentAmount(item.price) }</p>
            </div>
            <TextModule/>
        </div>
    </div>)
}

export default Product